module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/f5c4ef6102752b2aa6d55771a73184d8.png";